/**
 * UI primitives de LandingV2.
 * Todos usan design tokens Tailwind (teal como acento, surface para neutros).
 */

export function Container({ children, className = "" }) {
  return (
    <div className={`mx-auto w-full max-w-[1200px] px-5 sm:px-8 overflow-x-clip ${className}`}>
      {children}
    </div>
  );
}

export function Section({ id, children, className = "" }) {
  return (
    <section id={id} className={`py-16 sm:py-24 overflow-x-clip ${className}`}>
      <Container>{children}</Container>
    </section>
  );
}

export function Badge({ children, tone = "teal" }) {
  const tones = {
    teal:    "bg-teal-50  text-teal-700  border-teal-200",
    neutral: "bg-surface-100 text-surface-700 border-surface-200",
    dark:    "bg-white/10 text-white/90 border-white/20",
  };
  return (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full border text-xs font-semibold tracking-wide uppercase ${tones[tone]}`}>
      {children}
    </span>
  );
}

export function Button({ as: As = "button", variant = "primary", size = "md", children, className = "", ...props }) {
  const sizes = {
    sm: "px-4 py-2 text-sm rounded-lg",
    md: "px-5 py-2.5 text-sm rounded-xl",
    lg: "px-7 py-3.5 text-base rounded-xl",
  };
  const variants = {
    primary: "bg-teal-700 hover:bg-teal-800 text-white font-semibold shadow-card hover:shadow-elevated transition-all duration-200",
    dark:    "bg-brand-900 hover:bg-brand-700 text-white font-semibold shadow-card hover:shadow-elevated transition-all duration-200",
    outline: "bg-white hover:bg-surface-50 text-surface-900 font-semibold border border-surface-200 hover:border-surface-300 transition-all duration-200",
    ghost:   "bg-transparent hover:bg-surface-100 text-surface-700 font-medium transition-all duration-200",
  };
  return (
    <As className={`inline-flex items-center justify-center gap-2 ${sizes[size]} ${variants[variant]} ${className}`} {...props}>
      {children}
    </As>
  );
}

export function Card({ children, className = "" }) {
  return (
    <div className={`bg-white rounded-2xl border border-surface-200 shadow-soft ${className}`}>
      {children}
    </div>
  );
}
